import { useQuery } from "@tanstack/react-query";
import { OrgUnitClient, PublishedQuoteListItemDto } from "@lib/ShiOneClient";
import { ApiClientConfig } from "../../../../auth/ApiClientConfig";
import ms from "ms";

const api = new OrgUnitClient(ApiClientConfig, import.meta.env.API_ENDPOINT);

const CACHE_KEY_ORG_QUOTES = "orgQuotes";

/**
 * Hook to fetch quotes for an org unit
 * @param orgUnitId - The org unit ID
 * @param enabled - Whether the query should be enabled (default: true)
 */
const useGetQuotes = (orgUnitId?: number, enabled = true) => {
  return useQuery<PublishedQuoteListItemDto[], Error>({
    queryKey: [CACHE_KEY_ORG_QUOTES, orgUnitId],
    queryFn: async () => {
      if (!orgUnitId) {
        throw new Error("Org Unit ID is required");
      }
      return api.getOrgQuoteList(orgUnitId);
    },
    staleTime: ms("10m"),
    enabled: enabled && !!orgUnitId,
  });
};

export default useGetQuotes;
